// extracted by mini-css-extract-plugin
module.exports = {"dimmedBackground":"FullscreenImageGallery_dimmedBackground__wsy25","carousel":"FullscreenImageGallery_carousel__EX0Wl","closeButton":"FullscreenImageGallery_closeButton__0fuAd"};